(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anka-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anka-size-guide')) {
    customElements.define('anka-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.anka-size-guide__open');
        trigger.addEventListener('click', () => dialog.showModal());
        this.querySelector('.anka-size-guide__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
